import React, {useEffect, useRef, useState} from 'react'

import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import BottomSheet from '../../modals/bottom-sheet';
import nn from '../../../assets/png/NN.png'
import { HiOutlineLightBulb } from 'react-icons/hi'


const EnterpriseNumber = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {
    const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
   
    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        const val = value.split('.').join('').split("-").join('')
        setDataToContext(step_ID, step_URL, name, val)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step: 'has-enterprise-name'})
    }

    const isValidForm = () => {
        const valToVlidate = inputData.enterprise_number
        return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        }) && !valToVlidate.includes("_")
    }

                 useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "3",
stepName: "pro info:what is your business number",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }

     }, [])
    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('pro_infos.pro_info_what_is_your_business_number.title')}</h3>
                        <a className={"link"} onClick={() => setShowModal(true)}>
                            <HiOutlineLightBulb /> <span>{ t('pro_infos.pro_info_what_is_your_business_number.tool_tip')}</span> </a>
                        <br/>
                        <br/>
                        
                        {step_form.map(input => (
                            <InputField
                            label={t(input.label)}
                            value={inputData[input.id]}
                            name={input.id}
                            getInputValue={getInputValue}
                            key={input.id}
                            error={error}
                            isBCE={true}
                            getDataFromContext={getDataFromContext}
                        />))}
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />
                
                {showModal &&
                <BottomSheet
                    title={""}
                    close={() => {setShowModal(false)}}
                >
                    <BaseParagraph>
                        {/* <h3>{ t('personal_infos.Personal_info_national_registration_number.modal.title')}</h3> */}
                        <p>{ t('pro_infos.pro_info_what_is_your_business_number.modal.text')}</p>
                    </BaseParagraph>
                </BottomSheet>}
            </StepsLoader>
        </>
    )
}

EnterpriseNumber.propTypes = {
    name: PropTypes.string
}

EnterpriseNumber.defaultProps = {
    name: "email-step"
}


export default EnterpriseNumber